module.exports = __webpack_public_path__ + "img/tips-support.c6f5c4b9.svg";